import { IconTile } from "@design";
import { Zap } from "lucide-react";

// See AgentIcon: the API stores an icon name + color per skill; a dynamic
// icon map lands with the picker. Default tile for the mock.
export function SkillIcon(_props: Readonly<{ icon: string }>) {
  return (
    <IconTile variant="neutral">
      <Zap size={16} aria-hidden />
    </IconTile>
  );
}
